
import React from 'react';
import { MeshLocation } from './meshLocationsData';
import { useTheme } from '@/components/theme/ThemeProvider';

interface MapLegendProps {
  locations: MeshLocation[];
}

const MapLegend: React.FC<MapLegendProps> = ({ locations }) => {
  const activeCount = locations.filter(l => l.status === 'active').length;
  const downCount = locations.filter(l => l.status === 'down').length;
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  
  // Calculate percentage with protection against division by zero
  const onlinePercentage = locations.length > 0 
    ? ((activeCount / locations.length) * 100).toFixed(0)
    : "0";
  
  // Brighter theme-aware colors
  const activeColor = '#00FF66'; // Bright green
  const downColor = '#FF3A3A';   // Bright red
  
  return (
    <div className="absolute bottom-4 left-4 bg-background/80 backdrop-blur-sm text-foreground p-3 rounded-lg border shadow-lg card-auto-height">
      <div className="text-sm font-medium mb-2 overflow-wrap-anywhere">Mesh Network Status</div>
      <div className="flex flex-wrap items-center gap-4">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: activeColor }}></div>
          <span className="text-sm font-medium overflow-hidden text-ellipsis">Active</span>
          <span className="text-xs text-muted-foreground overflow-hidden text-ellipsis">({activeCount})</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: downColor }}></div>
          <span className="text-sm font-medium overflow-hidden text-ellipsis">Down</span>
          <span className="text-xs text-muted-foreground overflow-hidden text-ellipsis">({downCount})</span>
        </div>
      </div>
      <div className="text-xs text-muted-foreground mt-1 overflow-wrap-anywhere">
        Total nodes: {locations.length} | 
        {onlinePercentage}% online
      </div>
    </div>
  );
};

export default MapLegend;
